import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseResponseModel } from 'src/app/models/base-response.model';
import { TronicTelemetryInterface } from 'src/app/view/main/7_tratamientos/control/dialog-tratamiento-manez/tronic-telemetry.interface';
import { GraficaManez } from 'src/app/view/main/7_tratamientos/trata-manez/grafica-manez.interface';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class GraficasService {
	private readonly baseUrl = 'ws/tratamientos/charts/';

	private readonly http = inject(HttpClient);

	getManezGraficas(
		id_tratamiento: string,
		n_tratamiento: number,
		id_maquinaria: string,
		fecha_tratamiento?: string,
	): Observable<GraficaManez> {
		const parametros = new URLSearchParams();
		parametros.append('id_tratamiento', id_tratamiento);
		parametros.append('idTreatment', n_tratamiento.toString());
		parametros.append('idMaquinaria', id_maquinaria);
		if (fecha_tratamiento) {
			parametros.append('fecha', fecha_tratamiento);
		}
		return this.http.get<GraficaManez>(
			`${environment.serverUrl + this.baseUrl}get_charts_data.php?${parametros.toString()}`,
		);
	}

	getDataCharts(imei: string, fecha_tratamiento?: string): Observable<GraficaManez[]> {
		const parametros = new URLSearchParams();
		parametros.append('imei', imei);
		parametros.append('fecha', fecha_tratamiento ?? '');
		if (fecha_tratamiento) {
			parametros.append('fecha', fecha_tratamiento);
		}
		return this.http.get<GraficaManez[]>(
			`${environment.serverUrl + this.baseUrl}get_charts_data_calendar_v2.php?${parametros.toString()}`,
		);
	}

	getTracksMyl(imei: string, fecha_tratamiento?: string): Observable<BaseResponseModel<TronicTelemetryInterface>> {
		const parametros = new URLSearchParams();
		parametros.append('p1', 'tratamientos');
		parametros.append('p2', 'get_coord_dismuntel_calendar');
		parametros.append('imei', imei);
		parametros.append('fecha', fecha_tratamiento ?? '');
		if (fecha_tratamiento) {
			parametros.append('fecha', fecha_tratamiento);
		}
		return this.http.get<BaseResponseModel<TronicTelemetryInterface>>(
			`${environment.serverUrl}ws/index.php?${parametros.toString()}`,
		);
	}

	getManezGraficasCalendar(imei: string, fecha_tratamiento?: string): Observable<GraficaManez> {
		return this.http.get<GraficaManez>(
			`${environment.serverUrl + this.baseUrl}get_charts_data_calendar.php?imei=${imei}&fecha=${fecha_tratamiento}`,
		);
	}
}
